export default __webpack_public_path__ + "static/media/progetto.4b150a0a.svg";